export default "__VITE_ASSET__326fee85__"